<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div
        class="fh5co-cover main-vis"
        data-stellar-background-ratio="0.5"
        style="background-image: url(/static/main_vis01.png)"
      >
      </div>
      <AppDownload />
      <div class="heading-feature text-center">
        君の脂肪を燃やし隊 3つの魅力
      </div>
      <div class="pos-rel mt-2 fh5co-lightgray-section">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-md-offset-2">
              <h1 class="heading-solid1 text-center mt-2">
                パーソナルトレーニングジム発信
              </h1>
              <ul>
                <li>一週間でダイエット</li>
                <li>各部位のトレーニング</li>
                <li>有酸素ダンス</li>
                <li>漢ヨガ などなど...</li>
              </ul>
            </div>
            <div class="col-md-3">
              <div class="row text-center feature1-image-container mt-2">
                <div class="col-md-12 col-sm-6">
                  <img
                    src="/static/feature01.jpg"
                    alt="Legame Online の魅力１ 動画でトレーニング"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-md-push-5 col">
              <h1 class="heading-solid1 text-center mt-2">
                管理栄養士監修！オリジナル食事Book付
              </h1>
              <p class="mt-2">
                普段利用しやすいコンビニでは何を買えばいいんだろう？油にもこんなに種類があるの！？<br />
                などなど、食からアプローチすることにより、ダイエットの成功率がアップします！
              </p>
            </div>
            <div class="col-md-3 col-md-pull-5 col-md-offset-2 col">
              <div class="row text-center feature1-image-container mt-2">
                <div class="col-md-12 col-sm-12">
                  <img
                    src="/static/feature02.jpg"
                    alt="トレーニング診断アプリ メニュー選択画面"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 fh5co-lightgray-section">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-md-offset-2 col">
              <h1 class="heading-solid1 text-center mt-2">
                管理栄養士による食事レシピ公開中
              </h1>
              <p class="mt-2"></p>
            </div>
            <div class="col-md-3 col">
              <div class="row text-center feature1-image-container mt-2">
                <div class="col-md-12 col-sm-12">
                  <img
                    src="/static/feature02_book.jpg"
                    alt="トレーニング診断アプリ トレーニング動画一覧画面"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MovieSample />
      <div class="dl-banner-container">
        <img
          src="/static/dl_banner.png"
          alt="ダウンロード"
        />
      </div>
      <AppDownload />
      <Media />
      <div class="web-training-container">
        <a href="/corporation" title="法人向けサービス">
          <img
            src="/static/web_training.png"
            alt="ダウンロード"
          />
        </a>
      </div>
      <Price />
      <AppDownload />
      <div id="fh5co-team-section" class="fh5co-lightgray-section">
        <div class="container">
          <div class="heading-section text-center animate-box">
            <h2>FAQ</h2>
          </div>
          <div class="faq-container">
            <div>
              <h2>どのようなデバイスで見れますか？</h2>
              <p>
                iPhone・Androidアプリをダウンロードしてご利用ください。法人プランにおいては、ホームページ内の会員メニューにアクセスし、パスワード設定することでログインが可能となります。
              </p>
            </div>
            <div>
              <h2>どんなジャンルのトレーニングがありますか？</h2>
              <p>
                ■ パーソナルジムが運営する、自重メインのトレーニング解説・実践動画<br />
                ■ お尻や太ももなど、気になる箇所ごとにまとめたトレーニング<br />
                ■ オリジナルのダンストレーニング動画<br />
                ■ 漢ヨガ<br />
                などなど、初級者から取り組めるトレーニングを取り揃えております。
              </p>
            </div>
            <div>
              <h2>支払い方法を教えてください</h2>
              <p>
                iPhone・Androidアプリをダウンロード後、コースを選び、決済確認となります。なお、法人様に関しては銀行振込、クレジット決済など、お気軽にご相談ください。
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Price from './Price.vue'
import Staff from './Staff.vue'
import Media from './Media.vue'
import AppDownload from './AppDownload.vue'
import MovieSample from './MovieSample.vue'
import axios from 'axios'
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Home',
  data() {
    return {
      movieNum: 160,
      slickOptions: {
        slidesToShow: 5,
        slidesToScroll: 2,
        swipe: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  mounted () {
    axios
      .get('https://firebasestorage.googleapis.com/v0/b/legame-e45b7.appspot.com/o/web%2Fmovie.json?alt=media&token=ae1080b2-ff35-42e5-bd79-38b4592c5d51')
      .then(response => (this.movieNum = response.data['count']))
  },
  components: {
    Header,
    Footer,
    Price,
    Staff,
    Media,
    AppDownload,
    MovieSample,
    Slick
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-vis {
  height: 60vw;
  min-height: 350px;
  background-repeat: no-repeat;
  background-position: center top;
}

.fh5co-cover .main-vis-container h2 {
  color: #fff;
}

.fh5co-lightgray-section{
  padding: 30px 0;
}

.dl-banner-container img{
  width: 100%;
}
.heading-feature{
  margin-top: 40px;
  font-weight: bold;
  font-size: 20px;
}

.campaign-text-bold{
  font-size: 18px;
}

.trx-vis-container {
  height: 400px;
  position: relative;
}

.trx-vis-container h2,
.trx-vis-container p {
  position: relative;
  color: #333;
  font-style: italic;
  text-align: center;
  font-weight: bold;
  text-shadow: #fff 2px 2px;
}

.trx-vis-container p small {
  text-shadow: none;
  font-weight: normal;
}

.trx-vis-container h2 {
  padding-top: 45px;
  padding-bottom: 20px;
  font-size: 48px;
}

.trx-vis-container del {
  text-shadow: #666 1px 1px;
}

.trx-vis-container strong {
  font-size: 36px;
}

.trx-vis-container h2 strong {
  font-size: 70px;
}

@media screen and (max-width: 450px) {
  .trx-vis-container h2 {
    padding-top: 50px;
    padding-bottom: 10px;
    font-size: 24px;
  }
}

.character-01 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 20vw;
  min-width: 100px;
}

.character-02 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20vw;
  min-width: 100px;
}

.comic-container {
  margin-bottom: 30px;
}

.comic-container img {
  width: 95%;
  margin: auto;
  border: 2px solid #ccc;
}

.web-training-container {
  text-align: center;
}
.web-training-container img {
  width: 95%;
  margin: auto;
}

.feature1-image-container img {
  margin-bottom: 5px;
}

.trx-personal-vis-container {
  height: 400px;
  background-image: url(/static/vis_trx2.jpg);
  background-color: #333;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.trx-personal-vis-container img {
  height: 50vh;
  position: absolute;
  bottom: 0;
  right: 0;
  max-height: 400px;
  min-height: 100px;
}

.trx-personal-vis-container h2 {
  padding: 80px 0 60px;
  text-align: center;
  color: #fff;
  font-size: 28px;
  text-shadow: #000 2px 2px;
  position: relative;
}

@media screen and (max-width: 640px) {
  .trx-personal-vis-container h2 {
    padding: 40px 0 160px;
    font-size: 18px;
  }
}

.price small {
  display: inline;
}

.faq-container {
  background-color: #fff;
  padding: 20px;
}
.faq-container h2 {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 3px #cdff19 solid;
  margin-bottom: 5px;
  padding-bottom: 5px;
}
.faq-container p {
  font-size: 18px;
  padding-bottom: 20px;
}

.btn-enlarge{
  font-size: 18px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue